import { axios } from "~/plugins/request"

export const state = () => {
	return {}
}
export const mutations = {}
export const actions = {
  initRefundOrderInfo({commit}, params) {
		return new Promise((resolve, reject) => {
      let refundableOrder = axios.get('/refund/findRefundableOrderByOrderId', {params})
      let refundReasons =  axios.get('/dictionary/findAllItemByTypeCode', {params: {typeCode: "refundReasons"}})
      let userOrgInfo = axios.get('/user/findCurrentUserOrgInfo')
      Promise.all([refundableOrder, refundReasons, userOrgInfo])
			.then(res => {
				resolve(res)
			}).catch(error=> {
				reject(error)
			})
    })
  },
  findById({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`refund/findById`, {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
	findRefundableOrder({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`refund/findRefundableOrder`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  findRefundableOrderByOrderId({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`refund/findRefundableOrderByOrderId`, {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  save({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`refund/save`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  findRefundOrder({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`refund/findRefundOrder`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  approve({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`refund/approveRefundOrderStart`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  deleteById({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`refund/deleteById`, {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  //已办查询
  findRefundOrderSubmit({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`refund/findRefundOrderSubmit`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  
}